export default function SpeakerRow(speaker) {

    return `
        <article class="speaker">

            <div class="speaker__name">

                ${speaker.name} ${speaker.surname}

            </div>

            <div class="speaker__affiliation">

                ${speaker.affiliation}

            </div>

            ${speaker.position ? `
                <div class="speaker__position">
                    ${speaker.position}
                </div>
            ` : ''}

        </article>
    `;

}

function initials(name) {

    return name
        .split(' ')
        .map(part => part[0])
        .join('');

}
